// Template-specific tag sets
export const TEMPLATE_TAG_SETS = {
  onboarding: [
    { label: "onboarding", value: "onboarding" },
    { label: "new-client", value: "new-client" },
    { label: "setup", value: "setup" },
    { label: "documentation", value: "documentation" },
  ],
  sales: [
    { label: "proposal", value: "proposal" },
    { label: "follow-up", value: "follow-up" },
    { label: "opportunity", value: "opportunity" },
    { label: "presentation", value: "presentation" },
    { label: "cold-outreach", value: "cold-outreach" },
    { label: "prospecting", value: "prospecting" },
    { label: "lead-generation", value: "lead-generation" },
    { label: "referrals", value: "referrals" },
    { label: "upsell", value: "upsell" },
    { label: "cross-sell", value: "cross-sell" },
    { label: "competitive-analysis", value: "competitive-analysis" },
  ],
  support: [
    { label: "security", value: "security" },
    { label: "backup", value: "backup" },
    { label: "maintenance", value: "maintenance" },
    { label: "troubleshooting", value: "troubleshooting" },
  ],
  operations: [
    { label: "reporting", value: "reporting" },
    { label: "documentation", value: "documentation" },
    { label: "process", value: "process" },
    { label: "review", value: "review" },
    { label: "invoicing", value: "invoicing" },
    { label: "billing", value: "billing" },
    { label: "accounts-receivable", value: "accounts-receivable" },
    { label: "contract-renewal", value: "contract-renewal" },
    { label: "forecasting", value: "forecasting" },
    { label: "vendor-management", value: "vendor-management" },
    { label: "consolidation", value: "consolidation" },
    { label: "cost-optimization", value: "cost-optimization" },
  ],
  marketing: [
    { label: "campaign", value: "campaign" },
    { label: "content", value: "content" },
    { label: "social-media", value: "social-media" },
    { label: "email-marketing", value: "email-marketing" },
  ],
  general: [
    { label: "meeting", value: "meeting" },
    { label: "research", value: "research" },
    { label: "planning", value: "planning" },
    { label: "follow-up", value: "follow-up" },
  ],
  "schooley-mitchell": [
    { label: "meca_sm", value: "meca_sm" },
    { label: "post-audit", value: "post-audit" },
    { label: "online-access", value: "online-access" },
    { label: "client-coordination", value: "client-coordination" },
    { label: "cost-optimization", value: "cost-optimization" },
    { label: "audit-followup", value: "audit-followup" },
    { label: "account-setup", value: "account-setup" },
  ],
  "west-tennessee-consulting": [
    { label: "wtc", value: "wtc" },
    { label: "consulting", value: "consulting" },
    { label: "project-management", value: "project-management" },
    { label: "client-meeting", value: "client-meeting" },
    { label: "proposal", value: "proposal" },
    { label: "implementation", value: "implementation" },
  ],
} as const;
